module.exports = __webpack_public_path__ + "static/media/copia.72dd793a.svg";